import React, { Fragment } from 'react';
import { Toaster } from 'react-hot-toast';
import {
  Chart as ChartJS,
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineController,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  registerables as registerablesJS,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Navigation from './navigation';
import { ThemeProvider } from './contexts/ThemeContext';
import AIChatWidget from './components/AIChatWidget';
import IdleLogout from './components/IdleLogout';
import './App.css';

// import { Chart } from 'react-chartjs-2';
ChartJS.register(...registerablesJS);
ChartJS.register(ChartDataLabels);

ChartJS.register(
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const App = () => {
  return (
    <ThemeProvider>
      <Fragment>
        <Navigation />
        <IdleLogout />
        <AIChatWidget />
        <Toaster position='bottom-center' reverseOrder={false} />
      </Fragment>
    </ThemeProvider>
  );
};

export default App;
